export default __webpack_public_path__ + "static/media/title_shapes2.0bf23547.svg";